import {Type} from '@mintdata/mint-kit/api/types/Type';
import {ErrorOrEmpty} from '@mintdata/mint-kit/api/types/Value';
import {ADate} from '@mintdata/mint-kit/api/values/ADate';
import {ADateTime} from '@mintdata/mint-kit/api/values/ADateTime';
import {AInteger} from '@mintdata/mint-kit/api/values/AInteger';
import {ANumber} from '@mintdata/mint-kit/api/values/ANumber';
import {AString} from '@mintdata/mint-kit/api/values/AString';
import {ATime} from '@mintdata/mint-kit/api/values/ATime';
import {BaseCoercionUtil} from '@mintdata/mint-kit/impl/coercionUtils/BaseCoercionUtil';

export class DateTimeCoercionUtil extends BaseCoercionUtil
{
    constructor()
    {
        super(Type.DateTime);
    }

    public toDate(from:ADateTime):ADate | ErrorOrEmpty
    {
        return new ADate(`${from.year}-${from.month}-${from.day}`);
    }

    public toTime(from:ADateTime):ATime | ErrorOrEmpty
    {
        return new ATime(from.hours, from.minutes, from.seconds, 0);
    }

    public toInteger(from:ADateTime):AInteger | ErrorOrEmpty
    {
        return new AInteger(from.getTime());
    }

    public toNumber(from:ADateTime):ANumber | ErrorOrEmpty
    {
        return new ANumber(from.getTime());
    }

    public toString(from:ADateTime):AString | ErrorOrEmpty
    {
        return new AString(from.getDate().toISOString());
    }
}
